export default __webpack_public_path__ + "static/media/0042.2c5717f0.jpg";